import type { ID, Offset } from '@octopus-do/octopus-project-core'
import { artBoardActions } from '@store/reducers/artboard'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { getCommentableId } from '../utils'

// keeps the page a thread would attach to in the store for Node to highlight
// it; the store is only touched when the target changes, not on every mouse
// move, so only the page left and the page entered re-render
export const useThreadTarget = () => {
  const dispatch = useDispatch()

  const target = useRef<ID | null>(null)

  const setTarget = (next: ID | null) => {
    if (next === target.current) {
      return
    }

    target.current = next
    dispatch(artBoardActions.setThreadTarget(next))
  }

  const trackTarget = (point: Offset) => {
    setTarget(getCommentableId(point))
  }

  const resetTarget = () => {
    setTarget(null)
  }

  // the comment mode can be left, and a bubble removed, with the page still
  // highlighted
  useEffect(
    () => () => {
      if (target.current) {
        dispatch(artBoardActions.setThreadTarget(null))
      }
    },
    [dispatch]
  )

  return { trackTarget, resetTarget }
}
